import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const SimTooltip = ({ text, placement = "top", children, ...tooltipProps }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={`tooltip-${placement}`} {...tooltipProps}>
          {text}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default SimTooltip;
